enum Approval {
  Approved = 'true',
  Unapproved = 'undefined',
}

export default Approval;
